<template>
    <div class="menu-watefall">
        <div class="company-info">
            <SidebarInfo  v-if="isShowSidebarInfo" :companyInfo="companyInfo" />
        </div>
        <div class="menu-work-plant">
            <div class="work-plant-item">
                <div class="work-plant-item-tit" @click="jumpGateWay">
                    <i class="iconfont icon-other-gongzuotai1"></i>
                </div>
                <div class="work-plant-item-child">
                   <div class="menu-system-child" v-for="(o,i) in workPlant.children" :key="i" @click="jumpUrl(o)">
                        <i :class="o.meta.icon" :style="'color:'+o.meta.color+';'"></i>{{o.meta.title}}
                    </div>
                </div>
            </div>
        </div>
        <div class="menu-system">
            <div class="menu-system-item" v-for="(item,index) in menuData" :key="index" @click.stop="jumpParentUrl(item)" v-if="item.sonMenu&&item.sonMenu.length>0">
                <div class="menu-system-item-tit" :style="'color:'+item.meta.color+','">
                   {{item.meta.title}}
                </div>
                <div class="menu-system-item-child" v-if="item.name!=='process'&&item.name!=='operation'&&item.name!=='application'">
                   <div class="menu-system-child" v-for="(obj,ind) in item.sonMenu" :key="ind" @click.stop="jumpUrl(obj)">
                       <i :class="obj.meta.icon" :style="'color:'+obj.meta.color+';'"></i>{{obj.meta.title}}
                    </div>
                </div>
                <div class="menu-system-item-child-group" v-else>
                   <div class="menu-system-child" v-for="(obj,ind) in item.sonMenu" :key="ind" v-if="isShowMenuItem(obj)">
                       <i :class="obj.meta.icon" :style="'color:'+obj.meta.color+';'"></i>{{obj.meta.title}}
                       <div class="menu-system-child-item" v-for="(child,c) in obj.children" :key="c" @click.stop="jumpUrl(child)">
                           <i :class="child.meta.icon" :style="'color:'+child.meta.color+';'"></i>{{child.meta.title}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu-user">
            <span class="item">
               <el-tooltip effect="dark" content="帮助" placement="top">
                  <el-button class="share-button" type="success" icon="el-icon-question" @click="handleHelp()" circle></el-button>
              </el-tooltip>
             </span>
             <span class="item">
               <el-tooltip effect="dark" content="商店" placement="top">
                  <el-button class="share-button" type="success" icon="el-icon-goods" @click="handleAppStore()" circle></el-button>
              </el-tooltip>
             </span>
             <span class="userName">
                {{userInfo.trueName}}
             </span>
            <el-dropdown class="avatar-container right-menu-item" trigger="click">
                <div class="avatar-wrapper">
                    <img v-if="imageUrl" :src="imageUrl" class="user-avatar">
                    <i class="el-icon-caret-bottom"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{userInfo.trueName}}</el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleBaseInfoSetting">个人基本信息</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleSwitchLayout">{{switchLayoutFlg?'切换至旧版布局':'切换至新版布局'}}</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleUpdPwd">密码设置</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleUpdFirstPage" v-if="userInfo.switchLayoutFlg==2">首页设置</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleLogout">退出</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import * as constants from '@/common/constants';
    import { isEmpty, cloneDeep } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import mixinsNav from '@/mixins/mixins-nav';
    import jsCookies from 'js-cookie';
    import { changeSwitchLayoutFlg, upgradeSysApply, loginOut, getCurrentUserInfo,
        getPublishedApplicationList, getMenuData, getUserWorkPlantEntry } from '@/data-model';
    import SidebarInfo from '@/components/Sidebar/SidebarInfo';
    export default{
        mixins: [mixinsNav],
        computed: {
            ...mapGetters([
                'routers',
                'userInfo'
            ])
        },
        components: {
            SidebarInfo: SidebarInfo
        },
        props: {
            resource: {
                type: String
            }
        },
        data () {
            return {
                menuData: [],
                workPlant: {},
                imageUrl: '',
                switchLayoutFlg: false,
                companyInfo: {},
                menuDataObj: {
                    workspace: [],
                    office: [],
                    operation: [],
                    message: [],
                    appCenter: [
                        {
                            id: 'businessSystem',
                            path: 'businessSystem',
                            name: 'businessSystem',
                            title: '应用中心',
                            icon: 'iconfont icon-other-yingyongzhongxin',
                            color: '#d81e06',
                            sl: 'func-body-content-item'
                        }
                    ],
                    process: [],
                    dashboard: [
                        {
                            id: 'dashBoradCenter',
                            path: 'dashBoradCenter',
                            name: 'dashBoradCenter',
                            title: '仪表盘',
                            icon: 'iconfont icon-other-yibiao',
                            color: '#1296db',
                            sl: 'func-body-content-item'
                        }
                    ],
                    application: [],
                    document: [],
                    system: [],
                    components: []
                },
                menuList: [],
                catchObj: {},
                isShowSidebarInfo: false
            };
        },
        watch: {
            routers (val) {
                if (val.length > 0) {
                    this.builderMenuData(val);
                }
            }
        },
        created () {
            this.initPageViewAuth(this.userInfo);
            if (this.routers.length > 0) {
                this.builderMenuData(this.routers);
            } else {
                this[constants.VUEX_ACTIONS_ROUTER_GET_ALL]();// 缓存菜单
            }
            this._getCurrentUserInfo();
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_ROUTER_GET_ALL,
                constants.VUEX_ACTIONS_USER_INFO
            ]),
            initPageViewAuth (userInfo) {
                if (!isEmpty(userInfo)) {
                    // 过滤出所有操作权限、特殊权限的数据
                    const roles = userInfo.resources.filter(item => {
                        return item.resourceType === 1 || item.resourceType === 2 || item.resourceType === 4;
                    });
                    this.hasAllPanePermission = roles.some(role => {
                        // 默认有配置应用的权限即可开放所有应用系统的页签
                        return [constants.CONST_PERMISSION_CONFIG_CONFIG_APPLICATION_TREENODE_BTN].includes(role.resourceDes);
                    });
                }
            },
            async initPage () {
                let route = await getMenuData();
                for (let i = 0; i < route.length; i++) {
                    let cur = cloneDeep(route[i]);
                    if (cur.name === 'login' || cur.name === 'registeFirst' || cur.name === 'registeFirst' || cur.name === 'forhelp' || cur.name === 'expAppStore' ||
                        cur.name === 'businessSystem' || cur.name === 'dashBoradCenter' || cur.name === 'linkFormDetail//:modelId/:formId/:dataId' ||
                        cur.name === 'forgetPwd' || cur.name === 'registeSecond' || cur.name === 'appCenter' || cur.name === 'dashboard' || cur.name === 'business' ||
                        cur.name === 'mySetting') {
                        continue;
                    } else {
                        let childrenMenu = cur.children;
                        this.catchObj[cur.name] = cur;
                        if (childrenMenu.length > 0) {
                            childrenMenu.forEach(item => {
                                if (item.isMenuWaterfall === true && item.name !== 'application-config' && item.name !== 'applicationDesignTitle' &&
                                    item.name !== 'processDesignTitle' && item.name !== 'messageDesignTitle' && item.name !== 'template' && item.name !== 'myApproval' &&
                                    item.name !== 'myProcess' && item.name !== 'myTask') {
                                    let title = item.meta.title;
                                    if (item.name === 'myProcessParticipant') {
                                        title = title + '-流程';
                                    } else if (item.name === 'myTaskParticipant') {
                                        title = title + '-任务';
                                    }
                                    let obj = {
                                        id: item.id,
                                        path: item.path,
                                        name: item.name,
                                        title: title,
                                        icon: item.meta.icon,
                                        color: item.meta.color,
                                        sl: 'func-body-content-item',
                                        meta: {
                                            title: title,
                                            icon: item.meta.icon,
                                            color: item.meta.color
                                        }
                                    };
                                    this.menuDataObj[cur.name].push(obj);
                                }
                            });
                        }
                    }
                }
                let catchArray = [];
                for (let i = 0; i < this.menuDataObj.application.length; i++) {
                    let cur = this.menuDataObj.application[i];
                    if (cur.name === 'notice-list' || cur.name === 'cronjob-config') {
                        this.menuDataObj.office.push(cur);
                    } else {
                        catchArray.push(cur);
                    }
                }
                this.menuDataObj.application = catchArray;
                let fileArray = [];
                for (let i = 0; i < this.menuDataObj.document.length; i++) {
                    let cur = this.menuDataObj.document[i];
                    if (cur.name === 'archiveTemplate') {
                        this.menuDataObj.application.push(cur);
                    } else {
                        fileArray.push(cur);
                    }
                }
                this.menuDataObj.document = fileArray;
                for (let i = 0; i < this.menuDataObj.components.length; i++) {
                    let cur = this.menuDataObj.components[i];
                    if (cur.name !== 'componentsDesignTitle') {
                        this.menuDataObj.application.push(cur);
                    }
                }
                let messageArray = [];
                for (let i = 0; i < this.menuDataObj.message.length; i++) {
                    let cur = this.menuDataObj.message[i];
                    if (cur.name === 'messageTemplateReceiverList') {
                        this.menuDataObj.application.push(cur);
                    } else {
                        messageArray.push(cur);
                    }
                }
                this.menuDataObj.message = messageArray;
                let processArray = [];
                for (let i = 0; i < this.menuDataObj.process.length; i++) {
                    let cur = this.menuDataObj.process[i];
                    if (cur.name === 'processDefinitionDesign' || cur.name === 'approvalDefinitionDesign' || cur.name === 'time-config' || cur.name === 'close-template') {
                        this.menuDataObj.application.push(cur);
                    } else {
                        processArray.push(cur);
                    }
                }
                this.menuDataObj.process = processArray;
                this.workPlant.children = this.menuDataObj.workspace;// 工作台
                this.menuList = [];
                this.addOtherMenu('1');
                this.catchObj.process.children = this.menuDataObj.process;
                this.menuList.push(this.catchObj.process);
                this.catchObj.document.children = this.menuDataObj.document;
                this.menuList.push(this.catchObj.document);
                this.catchObj.office.children = this.menuDataObj.office;
                this.menuList.push(this.catchObj.office);
                this.catchObj.operation.children = this.menuDataObj.operation;
                this.menuList.push(this.catchObj.operation);
                this.addOtherMenu('2');
                this.catchObj.system.children = this.menuDataObj.system;
                this.menuList.push(this.catchObj.system);
                this.catchObj.message.children = this.menuDataObj.message;
                this.menuList.push(this.catchObj.message);
                this.catchObj.application.children = this.menuDataObj.application;
                this.catchObj.application.meta.title = '设计中心';
                this.menuList.push(this.catchObj.application);
                this.getApplications();
                this.getAllDashBoard();
                // this.menuList = cloneDeep(this.menuList);
            },
            initCompany (obj) {
                this.percentage = 30;
                if (isEmpty(obj)) {
                    this.navLogin();
                } else if (obj.companyInfo) {
                    this.companyInfo = obj.companyInfo;
                    this.companyInfo.percentage = 30;
                    if (this.companyInfo.isPay > 0) {
                        this.isShowSidebarInfo = true;
                    } else {
                        this.isShowSidebarFreeInfo = true;
                    }
                }
            },
            jumpUrlWorkPlant () {
                let cur = this.workPlant.children[0];
                let url = '/' + cur.id;
                let name = cur.name;
                this.navigateNameTo(url, name);
            },
            jumpUrl (val) {
                let param = {};
                if (val.defaultAppId) {
                    param.appId = val.defaultAppId;
                }
                if (val.boardCenterSelectName) {
                    window.sessionStorage.setItem('boardCenterSelectName', val.boardCenterSelectName);
                }
                let url = '/' + val.id;
                let name = val.name;
                window.sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                window.localStorage.setItem('isNewPageInitLoad' + this.userInfo.userId, '1');
                this.navigateNameTo(url, name, param);
                let u = window.location.href;
                if (u.indexOf(val.name) !== -1) {
                    window.location.reload();
                }
            },
            isShowMenuItem (obj) {
                if (obj.meta) {
                    return true;
                } else {
                    return false;
                }
            },
            jumpParentUrl (item) {
                let val = '';
                if (item.name === 'process' || item.name === 'operation' || item.name === 'application') {
                    val = item.sonMenu[0].children[0];
                } else {
                    val = item.sonMenu[0];
                }
                if (val.defaultAppId) {
                    window.localStorage.setItem('defaultAppId', val.defaultAppId);
                }
                if (val.boardCenterSelectName) {
                    window.sessionStorage.setItem('boardCenterSelectName', val.boardCenterSelectName);
                }
                let url = '/' + val.id;
                let name = val.name;
                if (item.name === 'business') {
                    let path = '/business/businessCenter';
                    let name = 'businessCenter';
                    this.navigateNameTo(path, name);
                } else {
                    this.navigateNameTo(url, name);
                }
            },
            builderApplication (val) {
                let child = [];
                for (let i = 0; i < val.length; i++) {
                    let cur = val[i];
                    if (cur.category == 0) {
                        let obj = {
                            path: 'businessSystem',
                            name: 'businessSystem',
                            id: 'businessSystem',
                            meta: {
                                title: cur.label,
                                icon: 'iconfont icon-other-yingyongzhongxin',
                                color: '#d81e06'
                            },
                            title: cur.label,
                            color: '#d81e06',
                            icon: 'iconfont icon-other-yingyongzhongxin',
                            defaultAppId: cur.id,
                            isShow: false,
                            isNewMenu: true,
                            isMenuWaterfall: true
                        };
                        child.push(obj);
                    }
                }
                this.menuData.forEach(item => {
                    if (item.name === 'business') {
                        item.sonMenu = child;
                        this.menuData = cloneDeep(this.menuData);
                    }
                });
            },
            async builderDashboard (val) {
                let child = [];
                for (let i = 0; i < val.length; i++) {
                    let cur = val[i];
                    let obj = {
                        path: 'dashBoradCenter',
                        name: 'dashBoradCenter',
                        id: 'dashBoradCenter',
                        title: cur.modelName,
                        icon: 'iconfont icon-other-yibiao',
                        color: '#1296db',
                        meta: {
                            title: cur.modelName,
                            icon: 'iconfont icon-other-yibiao',
                            color: '#1296db'
                        },
                        isShow: false,
                        isNewMenu: true,
                        isMenuWaterfall: true,
                        boardCenterSelectName: JSON.stringify(cur)
                    };
                    child.push(obj);
                }
                this.menuData.forEach(item => {
                    if (item.name === 'dashboard') {
                        item.sonMenu = child;
                        this.menuData = cloneDeep(this.menuData);
                    }
                });
            },
            builderMenuData (val) {
                this.menuData = [];
                let catchObj = {};
                for (let i = 0; i < val.length; i++) {
                    let cur = val[i];
                    catchObj[cur.name] = cur;
                }
                this.addOtherMenu('1');
                let processTemplate = {// 流程模板
                    children: []
                };
                let myApplove = {// 我的审批
                    children: []
                };
                let myProcess = {// 我的流程
                    children: []
                };
                let myTask = {// 我的任务
                    children: []
                };
                let processDesign = {// 流程设计
                    children: []
                };
                let processChildren = [];
                if (catchObj.process && catchObj.process.children.length > 0) { // 构造流程瀑布流
                    for (let i = 0; i < catchObj.process.children.length; i++) {
                        let cur = catchObj.process.children[i];
                        if (cur.name === 'processDesignTitle') { // 流程设计
                            cur.children = processDesign.children;
                            processDesign = cloneDeep(cur);
                        } else if (cur.name === 'approvalDefinitionDesign' || cur.name === 'processDefinitionDesign' || cur.name === 'time-config' || cur.name === 'close-template') {
                            processDesign.children.push(cur);
                        } else if (cur.name === 'template') {
                            cur.children = processTemplate.children;
                            processTemplate = cloneDeep(cur);
                        } else if (cur.name === 'processTemplateApproval' || cur.name === 'processTemplateProcess') {
                            processTemplate.children.push(cur);
                        } else if (cur.name === 'myApproval') {
                            cur.children = myApplove.children;
                            myApplove = cloneDeep(cur);
                        } else if (cur.name === 'myApprovalApply' || cur.name === 'myApprovalApprove' || cur.name === 'myApprovalCarbonCopy') {
                            myApplove.children.push(cur);
                        } else if (cur.name === 'myProcess') {
                            cur.children = myProcess.children;
                            myProcess = cloneDeep(cur);
                        } else if (cur.name === 'myProcessStartedBy' || cur.name === 'myProcessParticipant' || cur.name === 'myProcessAssignee') {
                            myProcess.children.push(cur);
                        } else if (cur.name === 'myTask') {
                            cur.children = myTask.children;
                            myTask = cloneDeep(cur);
                        } else if (cur.name === 'myTaskAssignee' || cur.name === 'myTaskParticipant') {
                            myTask.children.push(cur);
                        }
                    }
                    processChildren.push(processTemplate);
                    processChildren.push(myApplove);
                    processChildren.push(myProcess);
                    processChildren.push(myTask);
                    catchObj.process.sonMenu = cloneDeep(processChildren);
                    this.menuData.push(catchObj.process);
                }
                let documentDesign = {// 文档设计
                    children: []
                };
                let documentChildren = [];
                if (catchObj.document && catchObj.document.children.length > 0) {
                    for (let i = 0; i < catchObj.document.children.length; i++) {
                        let cur = catchObj.document.children[i];
                        if (cur.name === 'archiveDesignTitle') { // 流程设计
                            cur.children = documentDesign.children;
                            documentDesign = cloneDeep(cur);
                        } else if (cur.name === 'archiveTemplate') {
                            documentDesign.children.push(cur);
                        } else {
                            documentChildren.push(cur);
                        }
                    }
                    this.menuData.push(catchObj.document);
                    catchObj.document.sonMenu = cloneDeep(documentChildren);
                }
                if (catchObj.office) {
                    catchObj.office.sonMenu = cloneDeep(catchObj.office.children);
                    this.menuData.push(catchObj.office);
                }
                let operationSonMenu = [];
                let operationDesign = {// 企业运营分析
                    children: []
                };
                if (catchObj.operation && catchObj.operation.children.length > 0) {
                    for (let i = 0; i < catchObj.operation.children.length; i++) {
                        let cur = catchObj.operation.children[i];
                        if (cur.name === 'tenantOperationTitle') { // 流程设计
                            cur.children = operationDesign.children;
                            operationDesign = cloneDeep(cur);
                        } else {
                            operationDesign.children.push(cur);
                        }
                    }
                    operationSonMenu.push(operationDesign);
                    catchObj.operation.sonMenu = operationSonMenu;
                    this.menuData.push(catchObj.operation);
                }
                this.addOtherMenu('2');
                let systemChildren = [];
                if (catchObj.system && catchObj.system.children.length > 0) {
                    for (let i = 0; i < catchObj.system.children.length; i++) {
                        let cur = catchObj.system.children[i];
                        if (cur.name !== 'companyDetail' && cur.name !== 'departmentAdd' &&
                             cur.name !== 'positionAdd' && cur.name !== 'employeeAdd' && cur.name !== 'roleAdd' && cur.name !== 'resourceAdd') { //  流程设计
                            systemChildren.push(cur);
                        }
                    }
                    catchObj.system.sonMenu = systemChildren;
                    this.menuData.push(catchObj.system);
                }
                let messageChildren = [];
                let messageDesign = {// 消息设计
                    children: []
                };
                if (catchObj.message && catchObj.message.children.length > 0) {
                    for (let i = 0; i < catchObj.message.children.length; i++) {
                        let cur = catchObj.message.children[i];
                        if (cur.name === 'messageDesignTitle') {
                            cur.children = messageDesign.children;
                            messageDesign = cloneDeep(cur);
                        } else if (cur.name === 'messageTemplateReceiverList') {
                            messageDesign.children.push(cur);
                        } else if (cur.name !== 'messageDetail') {
                            messageChildren.push(cur);
                        }
                    }
                    catchObj.message.sonMenu = messageChildren;
                    this.menuData.push(catchObj.message);
                }
                let componentsDesign = {// 组件设计
                    children: []
                };
                if (catchObj.components && catchObj.components.children.length > 0) {
                    for (let i = 0; i < catchObj.components.children.length; i++) {
                        let cur = catchObj.components.children[i];
                        if (cur.name === 'componentsDesignTitle') {
                            cur.children = componentsDesign.children;
                            componentsDesign = cloneDeep(cur);
                        } else {
                            componentsDesign.children.push(cur);
                        }
                    }
                }
                let applicationChildren = [];
                let applicationDesign = {// 应用设计
                    children: []
                };
                if (catchObj.application && catchObj.application.children.length > 0) {
                    for (let i = 0; i < catchObj.application.children.length; i++) {
                        let cur = catchObj.application.children[i];
                        if (cur.name === 'applicationDesignTitle') {
                            cur.children = applicationDesign.children;
                            applicationDesign = cloneDeep(cur);
                        } else if (cur.name === 'application-tree' || cur.name === 'model-config' || cur.name === 'model-assign') {
                            applicationDesign.children.push(cur);
                        } else if (cur.name === 'cronjob-config' || cur.name === 'notice-list') {
                            catchObj.office.sonMenu.push(cur);
                        }
                    }
                    applicationChildren.push(componentsDesign);
                    applicationChildren.push(applicationDesign);
                    applicationChildren.push(processDesign);
                    applicationChildren.push(documentDesign);
                    applicationChildren.push(messageDesign);
                    catchObj.application.sonMenu = applicationChildren;
                    this.menuData.push(catchObj.application);
                }
                this.getApplications();
                this.getAllDashBoard();
                this.workPlant = catchObj.workspace;
            },
            async getApplications () {
                let apps = await getPublishedApplicationList();
                this.builderApplication(apps);
            },
            async getAllDashBoard () {
                // let param = {modelType: 5, userId: this.userInfo.userId, currentPage: 1, pageSize: 1000};
                // let res = await getModelListByType(param);
                let res = await getUserWorkPlantEntry({mode: 2});
                // console.log(workPlantEntry);
                // console.log(res.data);
                if (res && res.data.length > 0) {
                    this.builderDashboard(res.data);
                }
            },
            addOtherMenu (o) {
                if (o === '1') { // 应用中心
                    let obj = {
                        redirect: 'noredirect',
                        name: 'business',
                        isMenuWaterfall: true,
                        meta: {
                            title: '应用中心',
                            icon: 'el-icon-cpu'
                        },
                        children: [
                            {
                                path: 'businessSystem',
                                name: 'businessSystem',
                                id: 'businessSystem',
                                meta: {
                                    title: '应用中心',
                                    icon: 'iconfont icon-other-yingyongzhongxin',
                                    color: '#d81e06'
                                },
                                isShow: false,
                                isNewMenu: true,
                                isMenuWaterfall: true
                            }
                        ]
                    };
                    if (this.resource === '2') {
                        obj.color = 'rgb(64, 158, 255)';
                    }
                    // this.menuList.push(obj);
                    this.menuData.push(obj);
                } else if (o === '2') { // 仪表盘
                    let obj = {
                        redirect: 'noredirect',
                        name: 'dashboard',
                        isMenuWaterfall: true,
                        color: '',
                        meta: {
                            title: '仪表盘',
                            icon: 'el-icon-cpu'
                        },
                        children: [
                            {
                                path: 'dashBoradCenter',
                                name: 'dashBoradCenter',
                                id: 'dashBoradCenter',
                                meta: {
                                    title: '仪表盘',
                                    icon: 'iconfont icon-other-yibiao',
                                    color: '#1296db'
                                },
                                isShow: false,
                                isNewMenu: true,
                                isMenuWaterfall: true
                            }
                        ]
                    };
                    if (this.resource === '1') {
                        obj.color = 'rgb(64, 158, 255)';
                    }
                    // this.menuList.push(obj);
                    this.menuData.push(obj);
                }
            },
            handleMyWarnMessage () {
                this.navMyWarnMessage();
            },
            handleMessage () {
                this.navMyMessage();
            },
            handleUpdPwd () {
                this.navUpdPwd();
            },
            handleUpdFirstPage () {
                this.navUpdFirstPage();
            },
            handleBaseInfoSetting () {
                this.navBaseInfoSetting();
            },
            handleHelp () {
                var url = '/forhelp';
                if (window.location.href.indexOf('#/') > -1) {
                    // 本地访问路径
                    url = '#' + url;
                } else {
                    url = '/bpm' + url;
                }
                url = 'https://www.bcbpm.com/bpm/forhelp';
                window.open(url);
            },
            handleAppStore () {
                this.navAppStore();
            },
            async handleSwitchLayout () {
                let msg = `切换布局需要重新登录，您确定要切换为` + (this.switchLayoutFlg ? `旧版布局` : `新版布局`) + `吗？【注意：第一次切换版本后需要联系管理员分配对应系统的权限】`;
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (this.layoutType === 'old') {
                        window.sessionStorage.setItem('isShowLeft', 2);
                        this.switchLayoutFlg = true;
                        this.isShowNewMenu = true;
                        await changeSwitchLayoutFlg(this.userInfo.userId, (this.switchLayoutFlg ? 2 : 1));
                        window.sessionStorage.setItem('isNewPageInitLoad', '1');
                        this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('hidden');
                        this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('new');
                        let obj = this.menuDataSource[0];
                        let url = obj.id;
                        this.$router.push({name: obj.name, path: `'/'${url}`});
                    } else {
                        window.sessionStorage.setItem('isShowLeft', 1);
                        this.switchLayoutFlg = false;
                        this.isShowNewMenu = false;
                        await changeSwitchLayoutFlg(this.userInfo.userId, (this.switchLayoutFlg ? 2 : 1));
                        window.sessionStorage.removeItem('isNewPageInitLoad');
                        this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('show');
                        this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('old');
                    }
                    this.handleLogout();
                }).catch(() => {});
            },
            async handleLogout () {
                await loginOut();
                window.localStorage.clear();
                window.sessionStorage.removeItem('currentUserType');
                window.sessionStorage.removeItem('currentUserInfo');
                window.localStorage.removeItem('currentUserInfo');
                window.sessionStorage.removeItem('isNewPageInitLoad');
                window.localStorage.clear();
                jsCookies.remove('JSESSIONID');
                this.navLogin();
            },
            setUserPic () {
                let prefix = '';
                let env = process.env.NODE_ENV;
                if (env === 'production') {
                    prefix = '/bcbpm';
                }
                if (this.userInfo.userPic) {
                    if (this.userInfo.userPic.startsWith('/images')) {
                        this.imageUrl = prefix + this.userInfo.userPic;
                    } else {
                        this.imageUrl = `${constants.API_IMG_DOWNLOAD}${this.userInfo.userPic}`;
                    }
                } else {
                    this.imageUrl = prefix + '/images/default.png';
                }
            },
            handleUpgradeApply () {
                if (this.userInfo.isEnterprise === 1) {
                    this.isShowUpgradeDialog = true;
                } else {
                    this.messageTip('只有注册账号可以发起申请', 'warning');
                }
            },
            async handleUpgradeApplyOK () {
                this.upgradeLoading = true;
                try {
                    await upgradeSysApply();
                } catch (error) {
                    console.error('发起申请失败', error);
                } finally {
                    this.isShowUpgradeDialog = false;
                    this.upgradeLoading = false;
                }
            },
            async _getCurrentUserInfo () {
                let userInfo = {};
                if (isEmpty(this.userInfo)) {
                    userInfo = await getCurrentUserInfo();
                    this[constants.VUEX_ACTIONS_USER_INFO](userInfo);
                } else {
                    userInfo = this.userInfo;
                }
                if (!userInfo) {
                    await loginOut();
                    window.localStorage.clear();
                    window.sessionStorage.removeItem('currentUserType');
                    window.sessionStorage.removeItem('currentUserInfo');
                    window.sessionStorage.removeItem('isNewPageInitLoad');
                    jsCookies.remove('JSESSIONID');
                    this.navLogin();
                }
                this.initCompany(userInfo);
                this.setUserPic();
            },
            jumpGateWay () {
                let menuData = window.localStorage.getItem('defaultIndexPage');
                if (menuData) {
                    let obj = JSON.parse(menuData);
                    let url = '/' + obj.id;
                    let name = obj.name;
                    let param = {appId: obj.defaultAppId};
                    if (obj.defaultAppId) {
                        window.localStorage.setItem('defaultAppId', obj.defaultAppId);
                    }
                    if (obj.boardCenterSelectName) {
                        window.sessionStorage.setItem('boardCenterSelectName', obj.boardCenterSelectName);
                    }
                    window.sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                    window.localStorage.setItem('isNewPageInitLoad' + this.userInfo.userId, '1');
                    this.navigateNameTo(url, name, param);
                } else {
                    let catchUrl = '/workspace/gateWay';
                    this.navigateNameTo(catchUrl, 'gateWay');
                }
            }
        }
    };
</script>

<style lang="less">
    .menu-watefall{
        display: flex;
        cursor: pointer;
        height: 60px;
        background: #ecf5ff;
        .company-info{
            height: 60px;
            line-height: 60px;
            width: 220px;
            cursor: pointer;
            /deep/ .sidebar-info{
                border:none;
                padding:0px;
                height: 60px;
                line-height: 60px;
                .el-form {
                    height: 60px;
                    line-height: 60px;
                    .el-row{
                        height: 60px;
                        line-height: 60px;
                        .el-col{
                           height: 60px;
                           line-height: 60px;
                           .avatar-wrapper{
                               height: 60px;
                               line-height: 60px;
                               margin-top: 0px;
                               .logo-avatar{
                                   margin-top: 6px;
                               }
                           }
                        }
                    }
                }
            }
        }
        .menu-work-plant{
            width: 100px;
            .work-plant-item{
                height: 60px;
                .work-plant-item-tit{
                    height: 60px;
                    .icon-other-gongzuotai1{
                        font-size: 30px;
                        font-weight: 600;
                        color:#1296db;
                        cursor: pointer;
                        margin-top: 18px;
                        margin-left: 10px;
                    }
                }
            }
            .work-plant-item-child{
                display: none;
            }
            .work-plant-item:hover{
                .work-plant-item-child{
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: 400px;
                    max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    flex-wrap: wrap;
                    .menu-system-child{
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        height: 40px;
                        line-height: 40px;
                        padding-left: 20px;
                        cursor: pointer;
                    }
                    .menu-system-child:hover{
                      background: #d4e4f5;
                    }
                }
            }
        }
        .menu-system{
            flex: 1;
            display: flex;
            .menu-system-item{
                width: 100px;
                position: relative;
                text-align: center;
               .menu-system-item-child,.menu-system-item-child-group{
                  display: none;
               }
               @media screen and (min-width: 1024px) and (max-width: 1366px) {
                    width: 88px;
                    font-size: 16px;
               }
            }
            .menu-system-item:hover{
                background: #d4e4f5;
                .menu-system-item-child{
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: 400px;
                    // max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    flex-wrap: wrap;
                    padding-bottom: 20px;
                    overflow: auto;
                    max-height: 80vh;
                    .menu-system-child{
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        height: 40px;
                        line-height: 40px;
                        padding-left: 20px;
                        cursor: pointer;
                    }
                    .menu-system-child:hover{
                      background: #d4e4f5;
                    }
                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        position: relative;
                        right: 200px;
                    }
                }
                .menu-system-item-child-group{
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: auto;
                    max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    .menu-system-child{
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        padding-left: 20px;
                        cursor: pointer;
                        font-size: 20px;
                        .iconfont{
                            font-size: 20px;
                        }
                        padding-bottom: 20px;
                        .menu-system-child-item{
                            width: 140px;
                            text-align: left;
                            height: 40px;
                            line-height: 40px;
                            padding-left: 20px;
                            cursor: pointer;
                            padding-left: 16px;
                            font-size: 16px;
                            .iconfont{
                                font-size: 16px;
                            }
                        }
                        .menu-system-child-item:hover{
                          background: #d4e4f5;
                        }
                    }
                }
            }
            .menu-system-item:last-child{
                .menu-system-item-child-group{
                   position: absolute;
                   right: -174px;
                }
            }
        }
        .menu-user{
            min-width: 180px;
            flex: 1;
            justify-content: end;
            height: 60px;
            line-height: 60px;
            padding-right: 10px;
            display: flex;
            .item{
               margin-right: 10px;
               .share-button{
                   padding: 4px;
                   border-radius: 10%;
               }
            }
            .avatar-container{
                margin-left: 10px;
            }
            .user-avatar{
                margin-top: 7px;
            }
            .userName{
                margin-top: 2px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/NavWaterfallMenu/NavWaterfallMenu.vue